import { request } from '../../api';
import { LISTINGS_QUERY, SLUG_QUERY } from '../listings';
import { GetSimilarListingBySlug } from './getSimilarListingBySlug.types';

const SIMILAR_QUERY = 'similar';

export const getSimilarListingBySlug: GetSimilarListingBySlug = async ({
  listingSlug,
  token = null,
  ignoreVisibility = '0',
}) => {
  const { data } = await request({
    query: `${LISTINGS_QUERY}/${SLUG_QUERY}/${listingSlug}/${SIMILAR_QUERY}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      ignore_visibility: ignoreVisibility,
    },
  });

  return data;
};
